import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import './i18n'
import './index.css'
import { reloadOnceForChunkError } from './components/ErrorBoundary'
import { answerFramedAuthResponse } from './lib/authBridge'
import { queryClient } from './lib/queryClient'

// A `<link rel="modulepreload">` or dynamic `import()` Vite issued
// for a route chunk fails to fetch -- the exact case a tab left open across a
// deploy hits on its next navigation, since the hash in its already-loaded JS
// no longer matches anything the server serves. `event.preventDefault()`
// stops Vite's own unhandled-rejection reporting; `reloadOnceForChunkError`
// (shared with the ErrorBoundary below) does the guarded one-time reload.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault()
  reloadOnceForChunkError()
})

void answerFramedAuthResponse().then((answered) => {
  if (answered) {
    document.body.innerHTML =
      '<p style="font:14px system-ui,sans-serif;color:#64748b;padding:2rem">Signing you in…</p>'
    return
  }
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </StrictMode>,
  )
})
